import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Accordion } from './ui/Accordion';
import { Timer, ShieldCheck, CreditCard, Check } from 'lucide-react';
const INCLUDED_TOOLS = ['📘 Manual de uso', '🧑\u200d⚕️ Ficha de Personal — Médicos', '👩\u200d⚕️ Ficha de Personal — Enfermería', '🗂️ Ficha de Personal — Administrativo', '🧹 Ficha de Personal — Servicios Generales', '📋 Control de Matrículas y Habilitaciones', '🕐 Planificador de Guardias y Turnos', '🤒 Control de Ausentismo y Licencias', '💰 Mapa de Adicionales por Convenio', '💉 Capacitaciones Obligatorias y Vacunación', '🦺 EPP y Libretas Sanitarias', '📊 Dashboard General (KPIs automáticos)', '📊 Reporte Mensual a Dirección', '📅 Calendario Anual de Vencimientos', '🆘 Banco de Suplentes', '🆕 Onboarding — Checklist de Ingreso', '🆕 Onboarding — Carta de Bienvenida', '📞 Directorio de Contactos Críticos', '🆕 Onboarding — Planilla de Entrega de Elementos', '🧮 Liquidador de Adicionales y Sueldo (BONUS)'];
export function FinalOffer() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section id="oferta" className="py-12 px-4 scroll-mt-4" data-id="element-73">
      <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-teal-100" data-id="element-74">
        <div className="bg-red-600 text-white text-center py-3 px-4 flex items-center justify-center gap-2" data-id="element-75">
          <Timer className="w-5 h-5 animate-pulse" data-id="element-76" />
          <span className="font-bold uppercase tracking-wide text-sm" data-id="element-77">
            Oferta expira en: {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>

        <div className="p-6 md:p-8" data-id="element-78">
          <h2 className="text-2xl font-bold text-center text-slate-900 mb-4" data-id="element-79">
            Resumen de tu pedido
          </h2>

          <div className="mb-6" data-id="element-80">
            <Accordion title="🛒 Ver todo lo que te llevás hoy (20 herramientas + bonos)" data-id="element-81">
              <ul className="divide-y divide-slate-100" data-id="element-82">
                {INCLUDED_TOOLS.map((tool, idx) => <li key={idx} className="flex items-center gap-2 py-1.5 text-[13px] text-slate-700" data-id="element-83">
                    <Check className="w-3.5 h-3.5 text-teal-600 flex-shrink-0" data-id="element-84" />
                    <span className="leading-tight" data-id="element-85">{tool}</span>
                  </li>)}
                <li className="flex justify-between items-center py-2 text-[13px]" data-id="element-86">
                  <span className="flex items-center gap-2 text-slate-700" data-id="element-87">
                    <ShieldCheck className="w-4 h-4 text-teal-600" data-id="element-88" /> Bono:
                    Modelo de Aislamiento Preventivo
                  </span>
                  <span className="font-bold text-teal-600" data-id="element-89">GRATIS</span>
                </li>
                <li className="flex justify-between items-center py-2 text-[13px]" data-id="element-90">
                  <span className="flex items-center gap-2 text-slate-700" data-id="element-91">
                    <ShieldCheck className="w-4 h-4 text-teal-600" data-id="element-92" />{' '}
                    Actualizaciones de por vida
                  </span>
                  <span className="font-bold text-teal-600" data-id="element-93">GRATIS</span>
                </li>
              </ul>
            </Accordion>
          </div>

          <div className="text-center mb-6" data-id="element-94">
            <p className="text-slate-400 line-through text-lg font-medium mb-1" data-id="element-95">
              Valor Normal: $58.990
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-96">
              <span className="text-4xl font-black text-teal-600" data-id="element-97">$19.990</span>
              <span className="text-sm font-bold text-white bg-red-500 px-2 py-1 rounded" data-id="element-98">
                ARS
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-99">
            <div className="flex justify-between text-xs font-bold text-slate-500 mb-2 uppercase" data-id="element-100">
              <span data-id="element-101">Cupos Disponibles</span>
              <span className="text-red-500" data-id="element-102">¡Solo quedan 27!</span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-3 overflow-hidden" data-id="element-103">
              <div className="bg-red-500 h-3 rounded-full" style={{
              width: '85%'
            }} data-id="element-104"></div>
            </div>
            <p className="text-center text-xs text-slate-400 mt-2" data-id="element-105">
              273 cupos reclamados de 300
            </p>
          </div>

          <Button className="mb-4" data-id="element-106">
            <span className="text-xl" data-id="element-107">Quiero mi Kit RRHH en orden</span>
            <span className="text-xs font-normal opacity-90 normal-case" data-id="element-108">
              Pago 100% Seguro y Encriptado
            </span>
          </Button>

          <div className="flex items-center justify-center gap-4 text-slate-400" data-id="element-109">
            <CreditCard className="w-6 h-6" data-id="element-110" />
            <ShieldCheck className="w-6 h-6" data-id="element-111" />
          </div>
        </div>
      </div>
    </section>;
}